export const formatTime = (date) => date.split('-').pop().trim();
